import { Link } from "react-router-dom";

const KPI_ROUTE_MAP = {
  projects: "/admin/projects",
  files: "/admin/files",
  users: "/admin/users",
};

export default function AdminKpiGrid({ kpis = [] }) {
  return (
    <div className="kpiGrid">
      {kpis.map((k, idx) => {
        const key = k.id ?? k.title ?? idx;
        const to = KPI_ROUTE_MAP[k.linkTo] || null;

        const className = `card kpiCard tone-${k.tone ?? "blue"} ${to ? "isLink" : ""}`;

        const content = (
          <>
            <p className="kpiTitle">{k.title}</p>
            <p className="kpiValue">{k.value}</p>

            <div className="kpiMeta">
              {k.momPct != null ? (
                <p
                  className={`mom ${k.momPct > 0 ? "up" : k.momPct < 0 ? "down" : ""}`}
                >
                  전월 대비 <span>{formatMomPct(k.momPct)}</span>
                </p>
              ) : null}

              {k.inc30d != null ? (
                <p className={`inc30d ${Number(k.inc30d) > 0 ? "up" : ""}`}>
                  <span>{toSigned(k.inc30d)}</span> ({k.date ?? "30일"})
                </p>
              ) : null}

              {Array.isArray(k.inc30ds) ? (
                <p className="inc30d">
                  {k.inc30ds.map((inc, i) => (
                    <span key={i} className={Number(inc) > 0 ? "up" : ""}>
                      <span>{toSigned(inc)}</span>
                      {i < k.inc30ds.length - 1 ? " / " : ""}
                    </span>
                  ))}{" "}
                  ({k.date ?? "30일"})
                </p>
              ) : null}

              {k.label ? <p className="inc30d">{k.label}</p> : null}
            </div>
          </>
        );

        if (!to) {
          return (
            <div key={key} className={className}>
              {content}
            </div>
          );
        }

        return (
          <Link key={key} className={className} to={to}>
            {content}
          </Link>
        );
      })}
    </div>
  );
}

const formatMomPct = (value) => {
  const n = Number(value);
  if (Number.isNaN(n)) return "-";
  if (n === 0) return "0%";
  return n > 0 ? `+${n}%` : `${n}%`;
};

const toSigned = (value) => {
  const n = Number(value);
  if (Number.isNaN(n)) return value ?? "-";
  if (n > 0) return `+${n}`;
  return `${n}`;
};
